import React from 'react';

const SVG = ({
  style = {},
  fill = '#000',
  viewBox = '0 0 24 18.262',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <g transform="translate(0 -242.4)">
      <g transform="translate(0 242.4)">
        <path
          fill={fill}
          d="M23.206 0H.817A.81.81 0 0 0 0 .817v13.02a.81.81 0 0 0 .817.817h8.794v2.138H7.688v1.471h8.163v-1.471h-1.919v-2.138h9.25a.81.81 0 0 0 .818-.817V.817A.776.776 0 0 0 23.206 0zM12.5 16.792h-1.453v-2.138H12.5zm10.071-3.6H1.443V1.453h21.129v11.74z"
        />
      </g>
      <g transform="translate(-9 228.901)">
        <path
          fill={fill}
          d="M0 0h13.939v1.147H0zm0 2.349h13.939V3.5H0zm0 2.357h9.833v1.147H0z"
          transform="translate(13 18)"
        />
      </g>
    </g>
  </svg>
);
export default SVG;
